import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link2, Pencil, Trash2 } from 'lucide-react';
import { TooltipIconButton } from '@/components/ui/tooltip-icon-button';
import type { VerificationItem } from '../../../types/verification';

export interface VerificationItemActionsProps {
  item: VerificationItem;
  onEditItem?: (item: VerificationItem) => void;
  onDeleteItem?: (itemId: string) => void;
}

const ACTION_BUTTON = 'size-6 [&_svg]:size-3.5';

const VerificationItemActions: React.FC<VerificationItemActionsProps> = ({
  item,
  onEditItem,
  onDeleteItem,
}) => {
  const { t } = useTranslation();

  return (
    <div className="flex">
      {item.sourceDrbfmSessionId && (
        <TooltipIconButton
          label={t('verification.drbfmLinkTooltip', 'DRBFM分析から生成')}
          icon={<Link2 strokeWidth={1.8} />}
          className={`${ACTION_BUTTON} text-success hover:text-success`}
          onClick={() => window.open(`/drbfm?session=${item.sourceDrbfmSessionId}`, '_blank')}
        />
      )}
      {onEditItem && (
        <TooltipIconButton
          label={t('common.edit')}
          icon={<Pencil strokeWidth={1.8} />}
          className={ACTION_BUTTON}
          onClick={() => onEditItem(item)}
        />
      )}
      {onDeleteItem && (
        <TooltipIconButton
          label={t('common.delete')}
          icon={<Trash2 strokeWidth={1.8} />}
          className={`${ACTION_BUTTON} text-destructive hover:text-destructive`}
          onClick={() => onDeleteItem(item.id)}
        />
      )}
    </div>
  );
};

export default VerificationItemActions;
